import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.title',
    defaultMessage: 'Try our Compliance Stage',
  },
  subtitle: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.subtitle',
    defaultMessage: 'And automate your document review!',
  },
  discover: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.discover',
    defaultMessage: 'Discover',
  },
  // Keep this skill slug aligned with its Cue configuration.
  // `hideMessage` hides the current chat bubble only; persisted text must read as a sentence.
  discoverCuePrompt: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.discoverCuePrompt',
    defaultMessage:
      'Use the activating-hire-compliance-trials skill to set up compliance on the "{openingTitle}" workflow, starting from the "{stageTitle}" stage.',
  },
  dismissAriaLabel: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.dismissAriaLabel',
    defaultMessage: 'Dismiss',
  },
});
